import { useMedia } from '@hooks/use-media';
import React from 'react';

import CartModal from './cart-drawer/cart-drawer';
import CartSidebar from './cart-sidebar/cart-sidebar';

export interface AppLayoutCartProps {
  readonly open: boolean;
  toggleOpen(isOpen?: boolean): void;
}

const AppLayoutCart: React.FC<React.PropsWithChildren<AppLayoutCartProps>> = ({
  children,
  open,
  toggleOpen,
}) => {
  const isCartDrawer = useMedia('cart-as-bottom-drawer', true);

  if (isCartDrawer) {
    return (
      <CartModal open={open} toggleOpen={toggleOpen}>
        {children}
      </CartModal>
    );
  } else {
    return (
      <CartSidebar open={open} toggleOpen={toggleOpen}>
        {children}
      </CartSidebar>
    );
  }
};

export default AppLayoutCart;
